import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe, DatePipe, DecimalPipe, PercentPipe } from '@angular/common';
import { PipeConfig } from '@shared/components/display-table-filter/display-table-filter.component';

@Pipe({ name: 'columnTransform' })
export class ColumnTransformPipe implements PipeTransform {

  readonly pipes: Record<string, PipeTransform> = {
    date: new DatePipe('en-US'),
    currency: new CurrencyPipe('en-US'),
    number: new DecimalPipe('en-US'),
    percent: new PercentPipe('en-US'),
  };

  transform(value: any, config?: PipeConfig): any {
    if (!config) {
      return value;
    }
    const pipe = this.pipes[config.name];
    return pipe ? pipe.transform(value, ...(config.args ?? [])) : value;
  }
}
